import { render, staticRenderFns } from "./BedrockGuardrailsManagement.vue?vue&type=template&id=4954055c&"
import script from "./BedrockGuardrailsManagement.vue?vue&type=script&lang=js&"
export * from "./BedrockGuardrailsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports